<template>
  <div class="ent-rel">
    <div class="ent-rel-col">
      <div class="ent-rel-title">
        <img src="@/assets/images/编组 26@2x.png" class="ent-rel-icon" alt="">
        供需入驻
      </div>
      <div class="ent-rel-panel">
        <div v-if="listings.length" class="ent-rel-list">
          <button
            v-for="row in listings"
            :key="'c-' + row.id"
            type="button"
            class="ent-rel-row"
            @click="openListing(row)"
          >
            <span class="ent-rel-name">{{ row.companyName || '未命名入驻' }}</span>
            <span class="ent-rel-sub">{{ row.requireMent || '查看入驻卡' }}</span>
          </button>
        </div>
        <div v-else class="ent-rel-empty">该企业暂无供需入驻</div>
        <div class="table-pagination">
          <GsPagination
            :current-page="listingPage"
            :page-size="pageSize"
            :total="listingTotal"
            @current-change="handleListingPage"
          />
        </div>
      </div>
    </div>
    <div class="ent-rel-col">
      <div class="ent-rel-title">
        <img src="@/assets/images/编组 26@2x.png" class="ent-rel-icon" alt="">
        数据集
      </div>
      <div class="ent-rel-panel">
        <div v-if="datasets.length" class="ent-rel-list">
          <button
            v-for="row in datasets"
            :key="'d-' + row.id"
            type="button"
            class="ent-rel-row"
            @click="goDataset(row)"
          >
            <span class="ent-rel-name">{{ row.registrationDataName || '未命名数据集' }}</span>
            <span class="ent-rel-sub">{{ row.dataContentIntroduction || '查看数据集档案' }}</span>
          </button>
        </div>
        <div v-else class="ent-rel-empty">该企业暂无已发布数据集</div>
        <div class="table-pagination">
          <GsPagination
            :current-page="datasetPage"
            :page-size="pageSize"
            :total="datasetTotal"
            @current-change="handleDatasetPage"
          />
        </div>
      </div>
    </div>

    <el-dialog
      v-model="showListing"
      title="供需入驻"
      width="720px"
      destroy-on-close
    >
      <el-form label-width="120px">
        <ListingCard
          :company="activeListing"
          :business-options="businessOptions"
          :is-demand="isDemandListing"
          :enterprise-id="enterpriseId"
          :enterprise-name="enterpriseName"
          variant="dialog"
        />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getDatasetList } from '@/api/api'
import { getListingList } from '@/api/Home/index.js'
import { P } from '@/router/paths'
import ListingCard from '@/components/ListingCard/index.vue'
import GsPagination from '@/components/GsPagination/index.vue'

export default {
  name: 'EnterpriseRelatedLists',
  components: { ListingCard, GsPagination },
  props: {
    enterpriseId: {
      type: [String, Number],
      default: ''
    },
    businessOptions: {
      type: Array,
      default: () => []
    },
    isDemand: {
      type: Boolean,
      default: false
    },
    enterpriseName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      listings: [],
      datasets: [],
      listingTotal: 0,
      datasetTotal: 0,
      listingPage: 1,
      datasetPage: 1,
      pageSize: 10,
      showListing: false,
      activeListing: {}
    }
  },
  watch: {
    enterpriseId: {
      immediate: true,
      handler() {
        this.listingPage = 1
        this.datasetPage = 1
        this.load()
      }
    }
  },
  computed: {
    isDemandListing() {
      const type = this.activeListing && this.activeListing.listingType
      if (type === '6' || type === 6) return true
      if (type === '5' || type === 5) return false
      return this.isDemand
    }
  },
  methods: {
    load() {
      this.loadListings()
      this.loadDatasets()
    },
    loadListings() {
      if (!this.enterpriseId) {
        this.listings = []
        this.listingTotal = 0
        return
      }
      getListingList({
        enterpriseId: this.enterpriseId,
        whetherPublish: '1',
        pageNum: this.listingPage,
        pageSize: this.pageSize
      }).then((res) => {
        const rows = (res && res.rows) || []
        this.listings = rows.filter((row) => String(row.enterpriseId) === String(this.enterpriseId))
        this.listingTotal = Number((res && res.total) || this.listings.length) || 0
      }).catch(() => {
        this.listings = []
        this.listingTotal = 0
      })
    },
    loadDatasets() {
      if (!this.enterpriseId) {
        this.datasets = []
        this.datasetTotal = 0
        return
      }
      getDatasetList({
        enterpriseId: this.enterpriseId,
        whetherPublish: '1',
        pageNum: this.datasetPage,
        pageSize: this.pageSize
      }).then((res) => {
        this.datasets = (res && res.rows) || []
        this.datasetTotal = Number((res && res.total) || this.datasets.length) || 0
      }).catch(() => {
        this.datasets = []
        this.datasetTotal = 0
      })
    },
    handleListingPage(page) {
      this.listingPage = page
      this.loadListings()
    },
    handleDatasetPage(page) {
      this.datasetPage = page
      this.loadDatasets()
    },
    openListing(row) {
      this.activeListing = row || {}
      this.showListing = true
    },
    goDataset(row) {
      if (!row || !row.id) return
      this.$router.push(P.datasetDetail(row.id))
    }
  }
}
</script>

<style scoped>
.ent-rel {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: stretch;
  margin-top: 20px;
}
.ent-rel-col {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.ent-rel-title {
  display: flex;
  align-items: center;
  height: 24px;
  font-family: AlimamaFangYuanTiVF-SemiBold, AlimamaFangYuanTiVF-SemiBold, sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #111824;
  line-height: 24px;
}
.ent-rel-icon {
  width: 28px;
  height: 18px;
  margin-right: 8px;
}
.ent-rel-panel {
  flex: 1;
  margin-top: 10px;
  min-height: 96px;
  padding: 15px;
  background: #fff;
  border-radius: 8px;
}
.ent-rel-list {
  display: flex;
  flex-direction: column;
}
.ent-rel-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  text-align: left;
  padding: 10px 4px;
  border: 0;
  border-bottom: 1px solid rgba(118, 118, 118, 0.13);
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}
.ent-rel-row:last-child {
  border-bottom: 0;
}
.ent-rel-row:hover .ent-rel-name {
  color: #0165FF;
}
.ent-rel-name {
  color: #111824;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
}
.ent-rel-sub {
  margin-top: 4px;
  color: #6B7789;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.ent-rel-empty {
  min-height: 66px;
  display: flex;
  align-items: center;
  padding: 4px 2px;
  color: #6B7789;
  font-size: 14px;
  line-height: 22px;
}
.table-pagination {
  margin-top: 12px;
}
.table-pagination :deep(.gs-pager) {
  margin: 8px 0 0;
  justify-content: flex-start;
}
@media (max-width: 960px) {
  .ent-rel {
    grid-template-columns: 1fr;
  }
}
</style>
